import React, { useState, useEffect } from 'react';
import './ListStory.scss';
import { Link } from 'react-router-dom';
import Layout from '../Layout/Layout';
import StoryItem from '../StoryItem/StoryItem';
import hackernews from '../../api/hackernews';
import HashLoader from 'react-spinners/HashLoader';

const ListStory = (props) => {
  const page = Number(props.page);
  const [listStories, setListStories] = useState([]);
  const [stories, setStories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMore, setIsMore] = useState(true);
  const min = (page - 1) * 30;

  useEffect(() => {
    const getListStories = async () => {
      try {
        const res = await hackernews.get(`/${props.type}.json`);
        setListStories(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    getListStories();
  }, [props.type]);

  useEffect(() => {
    const getStories = async () => {
      setIsLoading(true);
      try {
        let _data = [];
        let max;

        if (page * 30 > listStories.length) {
          max = (page - 1) * 30 + (listStories.length % 30);
          setIsMore(false);
        } else {
          max = page * 30;
        }

        if (min < listStories.length) {
          for (let i = min; i < max; i++) {
            const res = await hackernews.get(`/item/${listStories[i]}.json`);
            _data.push(res.data);
          }
        }
        setIsLoading(false);
        setStories(_data);
      } catch (err) {
        console.log(err);
      }
    };
    if (listStories.length > 0) {
      getStories();
    }
  }, [listStories, min, page]);

  const getLinkMore = () => {
    if (props.type === 'topstories') {
      return `/page/${page + 1}`;
    } else if (props.type === 'newstories') {
      return `newest/page/${page + 1}`;
    } else if (props.type === 'askstories') {
      return `ask/page/${page + 1}`;
    } else if (props.type === 'jobstories') {
      return `jobs/page/${page + 1}`;
    }
  };

  return (
    <Layout>
      {isLoading ? (
        <div className="loading-container">
          <HashLoader size={50} color={'#ff6600'} loading={isLoading} />
        </div>
      ) : (
        <div>
          {stories.length > 0 &&
            stories.map((story, idx) => {
              return (
                <StoryItem
                  story={story}
                  idx={idx + min}
                  key={story.id}
                  type={props.type}
                />
              );
            })}
          {isMore && (
            <Link to={getLinkMore()}>
              <p className="more-story">More</p>
            </Link>
          )}
        </div>
      )}
    </Layout>
  );
};

export default ListStory;
